module.exports = __webpack_public_path__ + "static/media/rentalpassport.40baa644.png";